import { SeoListName } from 'shared/analytics/types'
import { LocalStorage } from 'shared/utils/storage'

//param url is for destination url in clicked banners
export function getPromotionIdFromUrl(url?: string  ): string {
  const windowClone = typeof window !== 'undefined' ? window : null

  if (!url) return windowClone?.location.pathname || ''

  const currentDomainUrl = windowClone?.location.origin

  const isWithDomain = url.startsWith('http')

  const isAppDomain =
    isWithDomain && currentDomainUrl && url.includes(currentDomainUrl)

  if (isAppDomain) {
    try {
      const urlObj = new URL(url)

      return urlObj.pathname
    } catch (error) {
      return url
    }
  }

  if (!isWithDomain && currentDomainUrl) {
    try {
      const urlObj = new URL(currentDomainUrl + url)

      return urlObj.pathname
    } catch (error) {
      return url
    }
  }

  return url
}

export interface SeoPromotionData {
  creativeName: string
  promotionId: string
}

const seoPromotionStorage = new LocalStorage('seo_promotion', 'session')

export class SeoPromotion {
  //last promotion(banner) clicked
  private static lastClickedPromotion: SeoPromotionData | undefined = undefined

  public static get(): SeoPromotionData | undefined {
    const lastPromotion =
      this.lastClickedPromotion || seoPromotionStorage.get(undefined)

    const slug = getPromotionIdFromUrl()

    const lastSelectedProduct = SeoLastSelectedProductDataStorage.get()

    if (lastSelectedProduct) {
      return lastSelectedProduct?.promotion
    }

    if (lastPromotion?.promotionId === slug) {
      return lastPromotion
    }

    return undefined
  }

  public static set({ creativeName, promotionId }: SeoPromotionData): void {
    const sanitizePromotionId = getPromotionIdFromUrl(promotionId)
    const newPromotion = {
      creativeName,
      promotionId: sanitizePromotionId
    }

    seoPromotionStorage.set(newPromotion)
    this.lastClickedPromotion = newPromotion
  }
}

interface SeoLastSelectedProduct {
  slug: string
}

interface SeoLastSelectedProductDataStoragePayload {
  product: SeoLastSelectedProduct
  promotion: SeoPromotionData
  listName: SeoListName
}

export class SeoLastSelectedProductDataStorage {
  private static lastProductSeoStorage = new LocalStorage(
    'lastProductSeoStorage',
    'session'
  )

  static get(): SeoLastSelectedProductDataStoragePayload | undefined {
    const slug = getPromotionIdFromUrl()
    const data = this.lastProductSeoStorage.get<{
      [key: string]: SeoLastSelectedProductDataStoragePayload
    }>({})

    return data?.[slug] || undefined
  }

  static set(product: SeoLastSelectedProduct, listName: SeoListName) {
    this.lastProductSeoStorage.set({
      [`/${product.slug}`]: {
        promotion: SeoPromotion.get(),
        product,
        listName
      }
    })
  }
}
